/**
 * @generated SignedSource<<c58e84ac832c2c19a3ee816d5756528a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_user">;
  readonly " $fragmentType": "PdpSharedAddToCartButton_user";
};
export type PdpSharedAddToCartButton_user$key = {
  readonly " $data"?: PdpSharedAddToCartButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAddItemToCart_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d1c7b4a3b8d995e8a37f071530c7e72c";

export default node;
